// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-text-editor-panel .panel-icon-button span {
  font-size: 16px;
  vertical-align: middle;
}
.fi-text-editor-panel .fi-insert-giphy {
  right: 0;
  bottom: 35px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-text-panel/simple-text-panel/simple-text-panel.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;EACA,sBAAA;AADZ;AAKI;EACI,QAAA;EACA,YAAA;AAHR","sourcesContent":[".fi-text-editor-panel {\r\n    .panel-icon-button {\r\n        span {\r\n            font-size: 16px;\r\n            vertical-align: middle;\r\n        }\r\n    }\r\n\r\n    .fi-insert-giphy {\r\n        right: 0;\r\n        bottom: 35px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
